import React from 'react';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import classes from './PageBuilderDivider.module.scss';
import type { DividerType } from './dividerConfigAggregator';

type PageBuilderDividerProps = DividerType;

/**
 * Return the PB Divider
 * @param props
 * @constructor
 */
export function PageBuilderDivider(props: PageBuilderDividerProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderDividerProps>(props);

    const dividerStyles = {
        width: props.lineWidth,
        borderWidth: props.lineThickness,
        borderColor: props.lineColor,
        margin: 0,
    };

    const dividerClassNames = [classes['root'], 'pageBuilderDividerGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        dividerClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Divider Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={advancedSettings}
            classNames={dividerClassNames}
        >
            <hr style={dividerStyles} />
        </PageBuilderElementWrapper>
    );
}
